"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _TablePagination = _interopRequireDefault(require("@mui/material/TablePagination"));

var _reactI18next = require("react-i18next");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _common = require("../../common");

var _excluded = ["hidden", "count", "page", "onChangePage", "rowsPerPage", "onChangeRowsPerPage"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'BrandTablePagination';
var classes = {
  tablePagination: "".concat(PREFIX, "-tablePagination")
};
var StyledTablePagination = (0, _styles.styled)(_TablePagination.default)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({}, (0, _common.TablePaginationStyles)(theme)), {}, _defineProperty({
    overflow: 'hidden',
    '& .MuiToolbar-root': {
      flexWrap: 'wrap',
      justifyContent: 'center'
    }
  }, "& .".concat(classes.tablePagination), {
    display: 'flex',
    justifyContent: 'center'
  }));
});

var BrandTablePagination = function BrandTablePagination(_ref2) {
  var hidden = _ref2.hidden,
      count = _ref2.count,
      page = _ref2.page,
      onChangePage = _ref2.onChangePage,
      rowsPerPage = _ref2.rowsPerPage,
      onChangeRowsPerPage = _ref2.onChangeRowsPerPage,
      others = _objectWithoutProperties(_ref2, _excluded);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(StyledTablePagination, _extends({
    labelRowsPerPage: t('rows_per_page'),
    className: (0, _clsx2.default)(classes.tablePagination, _defineProperty({}, classes.hidden, hidden)),
    component: "div",
    count: count || 0,
    page: count ? page : 0,
    onPageChange: onChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: onChangeRowsPerPage
  }, others));
};

var _default = BrandTablePagination;
exports.default = _default;